export const convertCustomVariables = (survey = []) =>
  Object.keys(survey.customVariables || {}).reduce((acc, cur) => {
    acc[cur] = JSON.parse(JSON.stringify(survey.customVariables[cur]))
    if (/^\S+_\d+$/.test(cur) && acc[cur].values.every(v => [0, 1].includes(v))) {
      const [_, key, position] = cur.match(/^(\S+)_(\d+)$/)

      acc[key] ||= { type: 'x', values: [] }
      acc[key].values.push(position)

      acc[cur].values = [0, 1]
      acc[cur].x = true
    }
    return acc
  }, {})
